import { render } from "./loader.html?vue&type=template&id=7620110a&external"
import script from "./loader.js?vue&type=script&lang=js&external"
export * from "./loader.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__